import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
	providedIn: 'root',
})
export class AIAssistantService {
	constructor(private http: HttpClient) {}

	private readonly urlPath = `${environment.apiUrl}aichatbot/clients`;

	getReply(clientId, request: any): Observable<any> {
		const headers = new HttpHeaders({
			'Content-Type': 'application/json',
			'Cache-Control': 'no-cache, no-store, must-revalidate, post-check=0, pre-check=0',
		});
		return this.http.post<any>(`${this.urlPath}/${clientId}/reply`, request, { headers: headers });
	}

	getAgentReply(clientId, request: any): Observable<any> {
		const headers = new HttpHeaders({
			'Content-Type': 'application/json',
			'Cache-Control': 'no-cache, no-store, must-revalidate, post-check=0, pre-check=0',
		});
		return this.http.post<any>(`${this.urlPath}/${clientId}/agentreply`, request, { headers: headers });
	}

	getLogs(clientId): Observable<any> {
		const headers = new HttpHeaders({
			'Content-Type': 'application/json',
			'Cache-Control': 'no-cache, no-store, must-revalidate, post-check=0, pre-check=0',
		});
		return this.http.get<any>(`${this.urlPath}/${clientId}/logs`, { headers: headers });
	}
}
